import { CurrencyRupee, Percent } from "@mui/icons-material";
import { Stack } from "@mui/material";
import { DynamicFormBuilderContainer } from "../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container";
import { FormItemTypes } from "../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity";
export var OrderSummaryPopup = function (_ref) {
    var _parseInt$toFixed, _parseInt, _parseInt$toFixed2, _parseInt2;
    var formValues = _ref.formValues, width = _ref.width;
    var elements = [{
            type: FormItemTypes.Accordian,
            name: '',
            value: null,
            columnSize: 12,
            sx: {
                border: 'none',
                bgcolor: 'background.secondary'
            },
            summary: [{
                    type: FormItemTypes.Typography,
                    name: 'RegistrationNo',
                    fontWeight: 'strong',
                    columnSize: true
                }, {
                    type: FormItemTypes.Typography,
                    name: 'taxableAmount',
                    fontWeight: 'strong',
                    columnSize: 0,
                    valueGetter: function (formValues, field) {
                        var _formValues$Items;
                        var totalAmountSum = (formValues === null || formValues === void 0 || (_formValues$Items = formValues.Items) === null || _formValues$Items === void 0 ? void 0 : _formValues$Items.reduce(function (sum, item) { return sum + ((item === null || item === void 0 ? void 0 : item.TotalAmount) || 0); }, 0)) || 0;
                        return " \u20B9 ".concat(totalAmountSum ? totalAmountSum : 0.00);
                    }
                }],
            detailPanelProps: {
                spacing: 0,
                gap: '12px',
                p: 2,
                borderRadius: 2,
                bgcolor: 'background.secondary'
            },
            elements: [],
            setFieldProps: function (state) {
                var _state$Items;
                return {
                    type: FormItemTypes.Accordian,
                    elements: state === null || state === void 0 || (_state$Items = state.Items) === null || _state$Items === void 0 ? void 0 : _state$Items.map(function (data, index) {
                        var _data$TotalAmount, _data$Rate, _data$DiscountPercent, _data$ChargesAmount;
                        return {
                            type: FormItemTypes.CardComponent,
                            name: '',
                            columnSize: 12,
                            sx: {
                                border: 'none'
                            },
                            contentProps: {
                                spacing: 1.5
                            },
                            elements: [{
                                    type: FormItemTypes.Typography,
                                    name: 'ChildName',
                                    label: data === null || data === void 0 ? void 0 : data.ChildName,
                                    value: "\u20B9 ".concat((_data$TotalAmount = data === null || data === void 0 ? void 0 : data.TotalAmount) !== null && _data$TotalAmount !== void 0 ? _data$TotalAmount : 0),
                                    containerProps: {
                                        display: 'inline-flex',
                                        justifyContent: 'space-between'
                                    },
                                    labelTypographyProps: {
                                        mb: 0,
                                        noWrap: true,
                                        fontWeight: 'medium',
                                        fontSize: 'base',
                                        color: 'secondary.700'
                                    },
                                    fontWeight: 'strong',
                                    columnSize: 12,
                                    color: 'text.primary'
                                }, {
                                    type: FormItemTypes.Divider,
                                    name: '',
                                    variant: 'fullWidth',
                                    columnSize: 12
                                }, {
                                    type: FormItemTypes.Typography,
                                    name: 'TotalAmount',
                                    label: 'Basic amount',
                                    value: "\u20B9 ".concat((_data$Rate = data === null || data === void 0 ? void 0 : data.Rate) !== null && _data$Rate !== void 0 ? _data$Rate : '0'),
                                    containerProps: {
                                        display: 'inline-flex',
                                        justifyContent: 'space-between'
                                    },
                                    labelTypographyProps: {
                                        mb: 0,
                                        noWrap: true,
                                        fontWeight: 'medium',
                                        fontSize: 'sm',
                                        color: 'text.secondary'
                                    },
                                    fontWeight: 'medium',
                                    columnSize: 12,
                                    color: 'text.primary'
                                }, {
                                    type: FormItemTypes.ContainerItem,
                                    name: '',
                                    columnSize: 12,
                                    spacing: 0,
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    elements: [{
                                            type: FormItemTypes.Typography,
                                            name: '',
                                            columnSize: 4,
                                            children: 'Discount_1',
                                            fontSize: 'sm',
                                            color: 'text.secondary',
                                            fontWeight: 'medium'
                                        }, {
                                            type: FormItemTypes.ContainerItem,
                                            name: '',
                                            columnSize: 8,
                                            spacing: 0,
                                            gap: 1,
                                            justifyContent: 'end',
                                            alignItems: 'center',
                                            elements: [{
                                                    type: FormItemTypes.Typography,
                                                    name: 'DiscountPercentage',
                                                    columnSize: 0,
                                                    value: "".concat((_data$DiscountPercent = data === null || data === void 0 ? void 0 : data.DiscountPercentage) !== null && _data$DiscountPercent !== void 0 ? _data$DiscountPercent : 0, " %"),
                                                    color: 'secondary',
                                                    fontWeight: 'medium'
                                                }, {
                                                    type: FormItemTypes.Divider,
                                                    name: '',
                                                    columnSize: 0,
                                                    orientation: 'vertical',
                                                    sx: {
                                                        height: '12px'
                                                    }
                                                }, {
                                                    type: FormItemTypes.Typography,
                                                    name: 'Discount',
                                                    columnSize: 0,
                                                    value: " \u20B9 ".concat((_data$ChargesAmount = data === null || data === void 0 ? void 0 : data.ChargesAmount) !== null && _data$ChargesAmount !== void 0 ? _data$ChargesAmount : 0)
                                                }]
                                        }]
                                }, {
                                    type: FormItemTypes.Typography,
                                    name: 'ChargesAmount',
                                    label: 'Charge',
                                    value: " \u20B9 ".concat(data === null || data === void 0 ? void 0 : data.DiscountAmount),
                                    containerProps: {
                                        display: 'inline-flex',
                                        justifyContent: 'space-between'
                                    },
                                    labelTypographyProps: {
                                        mb: 0,
                                        noWrap: true,
                                        fontWeight: 'medium',
                                        fontSize: 'sm',
                                        color: 'text.secondary'
                                    },
                                    fontWeight: 'medium',
                                    columnSize: 12,
                                    color: 'text.primary'
                                }, {
                                    type: FormItemTypes.Typography,
                                    name: 'TaxableAmount',
                                    label: 'Taxable amount',
                                    value: " \u20B9 ".concat(data === null || data === void 0 ? void 0 : data.TaxableAmount),
                                    containerProps: {
                                        display: 'inline-flex',
                                        justifyContent: 'space-between'
                                    },
                                    labelTypographyProps: {
                                        mb: 0,
                                        noWrap: true,
                                        fontWeight: 'medium',
                                        fontSize: 'sm',
                                        color: 'text.secondary'
                                    },
                                    fontWeight: 'medium',
                                    columnSize: 12,
                                    color: 'text.primary'
                                }, {
                                    type: FormItemTypes.ContainerItem,
                                    name: '',
                                    columnSize: 12,
                                    spacing: 0,
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    elements: [{
                                            type: FormItemTypes.Typography,
                                            name: '',
                                            columnSize: 4,
                                            children: 'CGST',
                                            fontSize: 'sm',
                                            color: 'text.secondary',
                                            fontWeight: 'medium'
                                        }, {
                                            type: FormItemTypes.ContainerItem,
                                            name: '',
                                            columnSize: 8,
                                            spacing: 0,
                                            gap: 1,
                                            justifyContent: 'end',
                                            alignItems: 'center',
                                            elements: [{
                                                    type: FormItemTypes.Typography,
                                                    name: 'CGSTPercentage',
                                                    columnSize: 0,
                                                    value: "".concat(data === null || data === void 0 ? void 0 : data.CGSTPercentage, " %"),
                                                    color: 'secondary',
                                                    fontWeight: 'medium'
                                                }, {
                                                    type: FormItemTypes.Divider,
                                                    name: '',
                                                    columnSize: 0,
                                                    orientation: 'vertical',
                                                    sx: {
                                                        height: '12px'
                                                    }
                                                }, {
                                                    type: FormItemTypes.Typography,
                                                    name: 'CGSTAmount',
                                                    columnSize: 0,
                                                    value: "\u20B9 ".concat(data === null || data === void 0 ? void 0 : data.CGSTAmount)
                                                }]
                                        }]
                                }, {
                                    type: FormItemTypes.ContainerItem,
                                    name: '',
                                    columnSize: 12,
                                    spacing: 0,
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    elements: [{
                                            type: FormItemTypes.Typography,
                                            name: '',
                                            columnSize: 4,
                                            children: 'SGST',
                                            fontSize: 'sm',
                                            color: 'text.secondary',
                                            fontWeight: 'medium'
                                        }, {
                                            type: FormItemTypes.ContainerItem,
                                            name: '',
                                            columnSize: 8,
                                            spacing: 0,
                                            gap: 1,
                                            justifyContent: 'end',
                                            alignItems: 'center',
                                            elements: [{
                                                    type: FormItemTypes.Typography,
                                                    name: 'SGST_UTGST_Percentage',
                                                    columnSize: 0,
                                                    value: " ".concat(data === null || data === void 0 ? void 0 : data.SGST_UTGST_Percentage, "%"),
                                                    color: 'secondary',
                                                    fontWeight: 'medium'
                                                }, {
                                                    type: FormItemTypes.Divider,
                                                    name: '',
                                                    columnSize: 0,
                                                    orientation: 'vertical',
                                                    sx: {
                                                        height: '12px'
                                                    }
                                                }, {
                                                    type: FormItemTypes.Typography,
                                                    name: 'SGST_UTGST_Amount',
                                                    columnSize: 0,
                                                    value: "\u20B9 ".concat(data === null || data === void 0 ? void 0 : data.SGST_UTGST_Amount)
                                                }]
                                        }]
                                }]
                        };
                    })
                };
            }
        }];
    var formData = [{
            type: FormItemTypes.Typography,
            name: '',
            value: 'Order summary',
            columnSize: 12,
            fontWeight: 'strong'
        }, {
            type: FormItemTypes.List,
            name: 'orderSummary',
            columnSize: 12,
            disableBorder: true,
            variant: 'expanded',
            value: formValues === null || formValues === void 0 ? void 0 : formValues.VehicleContractDetails,
            disableCheckboxSelection: true,
            disableDetailsPanel: true,
            getRowHeight: function () { return 'auto'; },
            containerProps: {
                sx: {
                    mb: '16px'
                }
            },
            elements: elements
        }, {
            type: FormItemTypes.ContainerItem,
            name: '',
            columnSize: 12,
            spacing: 0,
            paddingLeft: '12px',
            paddingRight: '32px',
            elements: [{
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    columnSize: 12,
                    spacing: 0,
                    alignItems: 'center',
                    elements: [{
                            type: FormItemTypes.Typography,
                            name: '',
                            columnSize: 4,
                            children: 'Discount',
                            fontSize: 'sm',
                            color: 'text.secondary',
                            fontWeight: 'medium'
                        }, {
                            type: FormItemTypes.ContainerItem,
                            name: '',
                            columnSize: 8,
                            spacing: 0,
                            elements: [{
                                    type: FormItemTypes.NumberInput,
                                    name: 'discountparsentage',
                                    columnSize: 4,
                                    value: 0,
                                    disabled: true,
                                    sx: {
                                        '& .MuiOutlinedInput-root': {
                                            borderRadius: '8px 0px 0px 8px'
                                        },
                                        '& .MuiOutlinedInput-notchedOutline': {
                                            borderRight: 'none !important'
                                        }
                                    },
                                    InputProps: {
                                        endAdornment: /*#__PURE__*/ React.createElement(Percent, {
                                            sx: {
                                                color: 'secondary.500',
                                                height: '16px',
                                                width: '16px'
                                            }
                                        })
                                    }
                                }, {
                                    type: FormItemTypes.NumberInput,
                                    name: 'discountamount',
                                    columnSize: 8,
                                    value: 0,
                                    disabled: true,
                                    sx: {
                                        '& .MuiOutlinedInput-root': {
                                            borderRadius: '0px 8px 8px 0px'
                                        }
                                    },
                                    InputProps: {
                                        startAdornment: /*#__PURE__*/ React.createElement(CurrencyRupee, {
                                            sx: {
                                                color: 'secondary.500',
                                                height: '16px',
                                                width: '16px'
                                            }
                                        }),
                                        style: {
                                            textAlignLast: 'end'
                                        }
                                    }
                                }]
                        }]
                }, {
                    type: FormItemTypes.Typography,
                    name: '',
                    label: 'Charges',
                    value: '0.00',
                    containerProps: {
                        display: 'inline-flex',
                        justifyContent: 'space-between'
                    },
                    labelTypographyProps: {
                        mb: 0,
                        noWrap: true,
                        fontWeight: 'strong',
                        color: 'text.secondary'
                    },
                    fontWeight: 'strong',
                    columnSize: 12,
                    color: 'text.primary'
                }, {
                    type: FormItemTypes.Typography,
                    name: '',
                    label: 'Taxable amount',
                    value: '0.00',
                    containerProps: {
                        display: 'inline-flex',
                        justifyContent: 'space-between'
                    },
                    labelTypographyProps: {
                        mb: 0,
                        noWrap: true,
                        fontWeight: 'strong',
                        color: 'text.secondary'
                    },
                    fontWeight: 'strong',
                    columnSize: 12,
                    color: 'text.primary'
                }, {
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    columnSize: 12,
                    spacing: 0,
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    elements: [{
                            type: FormItemTypes.Typography,
                            name: '',
                            columnSize: 4,
                            children: 'CGST',
                            fontSize: 'sm',
                            color: 'text.secondary',
                            fontWeight: 'medium'
                        }, {
                            type: FormItemTypes.ContainerItem,
                            name: '',
                            columnSize: 8,
                            spacing: 0,
                            gap: 1,
                            justifyContent: 'end',
                            alignItems: 'center',
                            elements: [{
                                    type: FormItemTypes.Typography,
                                    name: '',
                                    columnSize: 0,
                                    value: '0 %',
                                    color: 'secondary',
                                    fontWeight: 'medium'
                                }, {
                                    type: FormItemTypes.Divider,
                                    name: '',
                                    columnSize: 0,
                                    orientation: 'vertical',
                                    sx: {
                                        height: '12px'
                                    }
                                }, {
                                    type: FormItemTypes.Typography,
                                    name: '',
                                    columnSize: 0,
                                    value: '₹ 0.00'
                                }]
                        }]
                }, {
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    columnSize: 12,
                    spacing: 0,
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    elements: [{
                            type: FormItemTypes.Typography,
                            name: '',
                            columnSize: 4,
                            children: 'SGST',
                            fontSize: 'sm',
                            color: 'text.secondary',
                            fontWeight: 'medium'
                        }, {
                            type: FormItemTypes.ContainerItem,
                            name: '',
                            columnSize: 8,
                            spacing: 0,
                            gap: 1,
                            justifyContent: 'end',
                            alignItems: 'center',
                            elements: [{
                                    type: FormItemTypes.Typography,
                                    name: '',
                                    columnSize: 0,
                                    value: '0 %',
                                    color: 'secondary',
                                    fontWeight: 'medium'
                                }, {
                                    type: FormItemTypes.Divider,
                                    name: '',
                                    columnSize: 0,
                                    orientation: 'vertical',
                                    sx: {
                                        height: '12px'
                                    }
                                }, {
                                    type: FormItemTypes.Typography,
                                    name: '',
                                    columnSize: 0,
                                    value: '₹ 0.00'
                                }]
                        }]
                }, {
                    type: FormItemTypes.Typography,
                    name: '',
                    label: 'Round- off',
                    value: "\u20B9 ".concat((_parseInt$toFixed = (_parseInt = parseInt(formValues === null || formValues === void 0 ? void 0 : formValues.GrandTotal)) === null || _parseInt === void 0 ? void 0 : _parseInt.toFixed(2)) !== null && _parseInt$toFixed !== void 0 ? _parseInt$toFixed : 0, " "),
                    containerProps: {
                        display: 'inline-flex',
                        justifyContent: 'space-between'
                    },
                    labelTypographyProps: {
                        mb: 0,
                        noWrap: true,
                        fontWeight: 'strong',
                        color: 'text.secondary'
                    },
                    fontWeight: 'strong',
                    columnSize: 12,
                    color: 'text.primary'
                }]
        }, {
            type: FormItemTypes.Divider,
            name: '',
            columnSize: 12
        }, {
            type: FormItemTypes.Typography,
            name: 'GrandTotal',
            label: 'Net payable amount',
            value: "\u20B9 ".concat((_parseInt$toFixed2 = (_parseInt2 = parseInt(formValues === null || formValues === void 0 ? void 0 : formValues.GrandTotal)) === null || _parseInt2 === void 0 ? void 0 : _parseInt2.toFixed(2)) !== null && _parseInt$toFixed2 !== void 0 ? _parseInt$toFixed2 : 0.00, " "),
            containerProps: {
                display: 'inline-flex',
                justifyContent: 'space-between'
            },
            labelTypographyProps: {
                mb: 0,
                noWrap: true,
                fontWeight: 'strong',
                color: 'text.primary'
            },
            fontWeight: 'strong',
            columnSize: 12,
            color: 'text.primary'
        }, {
            type: FormItemTypes.Divider,
            name: '',
            columnSize: 12
        }];
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Stack, {
        sx: {
            width: {
                xs: '100%',
                sm: '360px',
                md: '400px'
            }
        }
    }, /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        formData: formData,
        gridProps: {
            p: '16px 12px',
            spacing: 1.5
        },
        gridSpacing: 0
    })));
};
